import React, {useState} from 'react';
import {Icon, Modal, Grid, Button} from 'semantic-ui-react';

const WtsCalendarioTechDetailsModal = () => {
  const [showModal, setShowModal] = useState(false);

  const showModalClick = (e, value) => {
    e.preventDefault();
    setShowModal(value);
  };

  return (
    <Modal open={showModal}
      trigger={
        <Icon name='info circle' size="big" color="blue" link
          onClick={(e) => showModalClick(e, true)} />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            Detalles técnicos: Calendario
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showModalClick(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid celled>
          <Grid.Row>
            <Grid.Column width={2}>Frontend</Grid.Column>
            <Grid.Column width={14}>
              /src/wts/catalogs/areas
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}>Backend</Grid.Column>
            <Grid.Column width={14}>
              <div>
                <strong>getWtsCoursesAreas</strong>: GET /wts/agenda/cursoAgenda?area=[areaId]
              </div>
              <div>
                <strong>createWtsCoursesArea</strong>: POST /wts/agenda/cursoAgenda
              </div>
              <div>
                <strong>updateWtsCoursesArea</strong>: PUT /wts/agenda/cursoAgenda
              </div>
              <div>
                <strong>deleteWtsCoursesArea</strong>: GET /wts/agenda/cursoAgenda?area=[areaId]&last_id=true
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}>BDD</Grid.Column>
            <Grid.Column width={14}>
              <div>WTS.TDE_CURSOS_AGENDA</div>
              <div>WTS.TDE_CURSOS_AGENDA_CONCE</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}>Manual de usuario</Grid.Column>
            <Grid.Column width={14}>
              <div style={{'display': 'flex', 'alignItems': 'center'}}>
                <a
                  href="https://scribehow.com/viewer/WTS__Modulo_de_programacion__NXtVf4nDTPSiHrM6KESpSA"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{'marginRight': '20px'}}
                >
                  Programación (Scribe - Externo)
                </a>
                <Button
                  as="a"
                  href="/media/docs/manualWTS.pdf"
                  download="manualWTS.pdf"
                  size="small"
                  color="blue"
                >
                  <Icon name="file pdf outline" /> Descargar PDF
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

export default WtsCalendarioTechDetailsModal;
